import { serverAddr, fileServerAddr } from "../networkConfig";
export default {
	getExpiry(params, pageInfo) {
		return serverAddr.post(
			`/expiry/expiry-batches/?page=${pageInfo.currentPage}`,
			params
		);
	},
	getAllExpiry(params,pageInfo) {
		return serverAddr.post(
			`/expiry/expiry-batches/?get_all=true`,
			params
		);
	},
	getExpiredData(params, pageInfo) {
		return serverAddr.get(
			`/outlet/${params.outlet}/inventory/stock-count/?expired=true&from_date=${params.from_date}&to_date=${params.to_date}`
		);
	},
	getExpiryAlert(id, pageInfo) {
		return serverAddr.get(
			`/expiry/trigger/?outlet=${id}&page=${pageInfo.currentPage}`
		);
	},
	deleteExpiryAlert(id) {
		return serverAddr.delete(`/expiry/trigger/${id}/`);
	},
	addExpiryAlert(params) {
		return serverAddr.post(`/expiry/trigger/create-update/`, params);
	},
	getNotifyExpiryUser(id) {
		return serverAddr.get(`expiry/notify/?outlet=${id}`);
	},
	getExpiryUser(id) {
		return serverAddr.get(
			`outlet/${id}/users/?fields=full_name,id,designation,email,access_level,access_outlet,access_outlet_name,phone_number,status&get_all=true`
		);
	},
	getAllCategories(id) {
		return serverAddr.get(`categories/?get_all=true`);
	},
	getAllSubCategories(id) {
		return serverAddr.get(`product/subcategory/?get_all=true`);
	},
	getArticlesForOutlet({ outletId, fields = [], get_all = true } = {}) {
		return serverAddr.get(`/article/?get_all=true`);
	}
};
